var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('plugin-home-how-it-works-v2-base-item',{attrs:{"item":_vm.item}},[_c('div',{staticClass:"plugin-home-how-it-works-item__image"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }